import React from 'react';
import { DataList } from '../../index.styled';
import { withTranslation, WithTranslation } from 'react-i18next';
import { GroupPolymer } from '../../../../../../../../../../models/group.model';

const Data = ({ values, t }: Props) => {
    const createRow = (polymer: GroupPolymer) => {
        return (
            <DataList.Row key={polymer.id}>
                <DataList.Cell>
                    {polymer.name}{' '}
                    {polymer.concentration && `(${polymer.concentration}%)`}
                </DataList.Cell>
            </DataList.Row>
        );
    };

    const renderDataRows = () => {
        return values.map(value => createRow(value));
    };

    return (
        <DataList>
            <DataList.Header>
                <DataList.HeaderRow>
                    <DataList.HeaderCell width={12}>
                        {t(
                            'master.groups.group.steps.polymers.polymersList.polymerName'
                        )}
                    </DataList.HeaderCell>
                </DataList.HeaderRow>
            </DataList.Header>
            <DataList.Body>{renderDataRows()}</DataList.Body>
        </DataList>
    );
};

interface Props extends WithTranslation {
    values: GroupPolymer[];
}

export default withTranslation('app')(Data);
